var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "downloading_FILL0_wght400_GRAD0_opsz48",
    d: "M109.916,241a31.734,31.734,0,0,1-20.648-10.589A33.537,33.537,0,0,1,83.2,220.392,32.342,32.342,0,0,1,81,208.5a31.876,31.876,0,0,1,8.268-21.911A31.173,31.173,0,0,1,110,176v4.887a57.069,57.069,0,0,0-7.534,2.137s-6.87,3.956-9.735,7.23a27.811,27.811,0,0,0-.041,36.491,27.455,27.455,0,0,0,17.227,9.367Zm7.168,0v-4.887a28.546,28.546,0,0,0,7.209-1.914,25.8,25.8,0,0,0,6.394-3.788l3.584,3.584a38.336,38.336,0,0,1-8.1,4.724A29.2,29.2,0,0,1,117.084,241Zm13.684-54.329a36.927,36.927,0,0,0-6.516-3.706,28.24,28.24,0,0,0-7.168-2.077V176a33.2,33.2,0,0,1,9.041,2.4,39.333,39.333,0,0,1,8.145,4.684Zm8.145,42.274-3.5-3.421a26.278,26.278,0,0,0,3.747-6.476,29.66,29.66,0,0,0,1.873-7.209H146a34.7,34.7,0,0,1-2.362,9.082A32.66,32.66,0,0,1,138.913,228.945Zm2.118-23.784a30.3,30.3,0,0,0-1.873-7.249,24.641,24.641,0,0,0-3.747-6.435l3.828-3.34A33.836,33.836,0,0,1,146,205.16Z",
    transform: "translate(-81 -176)",
    fill: "#70c382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.683c25fdb6695662e9ee2a6f969d3406.svg";
export { ForwardRef as ReactComponent };